/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosError } from 'axios';
import Core from '../core';

async function getLeaveEligibilities(company_id: number, employee_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/empLeaveBalances?company_id=${company_id}&emp_id=${employee_id}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getEmployeeAppliedLeaves(
  company_id: number,
  employee_id: number,
  typeFilter = '',
) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/getEmpAppliedLeaves?company_id=${company_id}&emp_id=${employee_id}&type=${typeFilter}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getEmployeeLeaveHistory(
  company_id: number,
  employee_id: number,
) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/getEmpLeaveHistory?company_id=${company_id}&emp_id=${employee_id}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getEmployeeLeaveHistoryWithYear(
  company_id: number,
  employee_id: number,
  year: number,
  type: string,
) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/getEmpLeaveHistory?company_id=${company_id}&emp_id=${employee_id}&year=${year}&type=${type}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getCompanyLeaveTypes(company_id: number, emp_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getCompanyLeaveTypes?company_id=${company_id}&emp_id=${emp_id}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getCompanyOtherPaymentTypes(company_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getCompanyOtherPaymentTypes?company_id=${company_id}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function applyLeave(payload: any) {
  const api = Core.getInstance().apiforImageUp();
  const data = await api.post(`/empApplyLeave`, payload);

  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function applyRejoinForm(payload: any) {
  const api = Core.getInstance().apiforImageUp();
  const data = await api.post(`/v2/leaves/rejoinForm`, payload);

  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function applyLeaveEncash(payload: any) {
  const api = Core.getInstance().apiforImageUp();
  const data = await api.post(`/empApplyLeaveEncash`, payload);

  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function cancelLeaveEncashment(payload: any) {
  const api = Core.getInstance().api();
  const data = await api.put(`/v2/leaveEncash/cancel`, payload);

  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function cancelLeaveAdvance(payload: any) {
  const api = Core.getInstance().api();
  const data = await api.put(`/v2/leaveAdvance/cancel`, payload);

  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function cancelLeave(payload: any) {
  const api = Core.getInstance().api();
  const data = await api.put(`/v1/leaves/cancel`, payload);

  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function sendRemanider(instanceId: number, empId: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v2/workflow-events/sendremainder-for-approval?instanceId=${instanceId}&empId=${empId}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getRejoinFormDetails(leaveID: number) {
  const api = Core.getInstance().api();
  const data = await api.get(`/v2/leave-rejoin-details?leaveID=${leaveID}`);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

export const leavesService = {
  getLeaveEligibilities,
  getEmployeeAppliedLeaves,
  getEmployeeLeaveHistory,
  getEmployeeLeaveHistoryWithYear,
  getCompanyLeaveTypes,
  applyLeave,
  applyLeaveEncash,
  getCompanyOtherPaymentTypes,
  cancelLeaveEncashment,
  cancelLeaveAdvance,
  cancelLeave,
  sendRemanider,
  applyRejoinForm,
  getRejoinFormDetails,
};
